import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import * as FAQAction from "~/store/faq/faqAction";
import { NonUpBeta } from "~/utils/func";
import { Delpath } from "~/utils/constants";
import { requestContentPages } from "~/store/resource/resourceAction";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const FaqDetailPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/FaqDetail"),
  loading: LoadableLoading
});
const FaqDetailPageTestDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/FaqDetailTest"),
  loading: LoadableLoading
});
class FaqDetail extends Component {
  componentDidMount() {
    if (NonUpBeta()) {
      const pathName = Delpath(this.props.location.pathname);
      this.props.requestContentPages(pathName);
    }
  }

  render() {
    return (
      <React.Fragment>
        {NonUpBeta() ? (
          <FaqDetailPageTestDesktop {...this.props} />
        ) : (
          <FaqDetailPageDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    faq,
    resource: { ContentPages }
  } = state;
  return {
    device: type,
    faq,
    ContentPages
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateShowedFAQByGroup: groupName =>
      dispatch(FAQAction.updateShowedFAQByGroup(groupName)),
    updateShowedFAQBySearch: searchValue =>
      dispatch(FAQAction.updateShowedFAQBySearch(searchValue)),
    getAllFAQ: () => dispatch(FAQAction.getAllFAQ()),
    requestContentPages: pathName => dispatch(requestContentPages(pathName))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FaqDetail);
